"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        minHeight: 84,
        maxHeight: 152,
        backgroundColor: 'transparent',
        fontSize: 14,
        border: `1px solid ${theme.grey5}`,
        borderRadius: 2,
        overflow: 'auto',
        fontWeight: 400,
        color: theme.grey1,
        padding: '8px 11px 9px 11px',
        transition: 'border-color 150ms linear 0ms',
        '& .DraftEditor-root': {
            overflow: 'auto'
        },
        '& .public-DraftEditorPlaceholder-root': {
            position: 'absolute',
            opacity: 0.5,
            zIndex: 1
        },
        '& .h1': {
            fontSize: 32,
            fontWeight: 'bold'
        },
        '& .ul': {
            position: 'relative',
            paddingLeft: 22,
            '&::before': {
                position: 'absolute',
                content: '"•"',
                color: theme.indigo3,
                fontWeight: 'bold',
                width: '1em',
                marginLeft: '-1em'
            }
        },
        '&[data-is-disabled="true"]': {
            opacity: 0.3
        },
        '&[data-has-focus="true"]': {
            borderColor: theme.indigo3
        },
        '&[data-is-placeholder-hidden="true"]': {
            '& .public-DraftEditorPlaceholder-root': {
                display: 'none'
            }
        }
    }
});
//# sourceMappingURL=richEditor.style.js.map